// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LinkDDefault } from '../../../assets/icons/default/general/link-d.svg?react';
import { ReactComponent as LinkDSolid } from '../../../assets/icons/solid/general/LINK-D.svg?react';
import { createIcons } from '../../Icon';
const LinkDIcon = /* @__PURE__ */ createIcons('LinkD', {
    default: LinkDDefault,
    solid: LinkDSolid
});
LinkDIcon.supportedTypes = ['default', 'solid'];
LinkDIcon.category = 'general';
export default LinkDIcon;
